import React from 'react';
import { Link } from 'react-router-dom';
import { suffix } from 'retinable';
import RaisedButton from 'material-ui/RaisedButton';
import styles from './PageNotFound.css';

const PageNotFound = () => (
    <div className={styles.page}>
        <div className={styles.logoWrap}>
            <Link to="/">
                <img
                    className={styles.logo}
                    alt="Runtrix Logo"
                    src={`/img/run-trix-logo${suffix()}.png`}
                    role="presentation"
                />
            </Link>
        </div>
        <div className={styles.overlay}>
            <div className={styles.notFoundContent}>
                <div className={styles.bigTitle}>404</div>
                <div className={styles.notFoundText}>
                    Oops! We can’t find that page. Looks like it ran away from us.<br />
                    (See what we did there?)
                </div>
                <Link to="/">
                    <RaisedButton
                        label="BACK HOME"
                        primary
                        labelStyle={{
                            height: '60px',
                            width: '200px',
                            lineHeight: '60px',
                            fontSize: 20,
                            fontFamily: 'Roboto',
                            letterSpacing: '1px',
                        }}
                        style={{
                            backgroundColor: '#3fb3e5',
                            width: '245px',
                            height: '60px',
                            margin: '30px',
                        }}
                    />
                </Link>
            </div>
        </div>
    </div>
);

export default PageNotFound;



/** WEBPACK FOOTER **
 ** ./src/Pages/PageNotFound.js
 **/